<ng-container *ngIf="pageView === MoneyBackGuaranteePageView.HOME">
  <div class="tw-w-full tw-px-4 tw-mb-6">
    <div class="tw-bg-gradient-black-to-light-black tw-py-2 tw-pt-3 tw-rounded-2.5 tw-flex tw-items-center tw-justify-evenly" (click)="onHomeBannerClick()">
      <div class="tw-flex tw-justify-center tw-items-center tw-px-2">
        <p class="money-back-guarantee-gradient-text tw-text-900 tw-font-bebas tw-leading-none">100%</p>
      </div>
      <span class="tw-w-[1px] tw-h-[30px] tw-bg-[rgba(255,255,255,0.1)]"></span>
      <div class="tw-flex tw-flex-col tw-leading-none tw-items-start tw-justify-center tw-gap-0.5 tw-px-2 tw-pr-3 tw-text-white tw-font-lexend tw-font-bold">
        <p class="tw-text-nowrap tw-text-gray-75" i18n="@@moneyBack">MONEY BACK</p>
        <p class="money-back-guarantee-gradient-text tw-uppercase" i18n="@@guarantee">guarantee</p>
      </div>
      <span class="tw-w-[1px] tw-h-[30px] tw-bg-[rgba(255,255,255,0.1)]"></span>
      <div class="tw-px-3 tw-pr-4 tw-text-white tw-flex tw-justify-center tw-items-center">
        <p class="tw-text-200 tw-font-lexend tw-leading-5 tw-text-gray-75">
          <span i18n="@@upgradeYourPlanNow" class="tw-mr-1">Upgrade Your <br/> Plan Now</span>
          <span class="tw-text-[#B49265] tw-text-100 tw-inline-block -tw-mb-[1px]">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="tw-w-2.5 tw-h-2.5 text-[#c7b189]"
          >
            <path
              d="M8 4 L16 12 L8 20"
              stroke="currentColor"
              stroke-width="3.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
        </svg>
        </span>
        </p>
      </div>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="pageView === MoneyBackGuaranteePageView.REGIMEN">
  <div class="tw-w-full tw-px-2.5 tw-pt-2.5 tw-mb-6 tw-relative tw-z-[5]" (click)="onRegimenBannerClick()">
    <div class="tw-bg-gradient-black-to-light-black tw-px-2 tw-py-1.5 sm:tw-py-2 tw-rounded-2.5 tw-flex tw-items-center tw-justify-between">
      <div class="tw-flex-1 tw-flex tw-justify-start">
        <div class="tw-flex tw-justify-center tw-items-center tw-px-1">
          <p class="money-back-guarantee-gradient-text tw-text-800 tw-font-bebas tw-leading-none -tw-mb-1">100%</p>
        </div>
        <span class="tw-w-[1px] tw-h-[30px] tw-bg-[rgba(255,255,255,0.1)] tw-mx-1"></span>
        <div class="tw-flex tw-flex-col tw-leading-none tw-items-start tw-justify-center tw-gap-0.5 tw-px-1 tw-text-white tw-font-bold">
          <p class="tw-text-nowrap tw-text-200 tw-text-gray-75 tw-font-medium tw-leading-none">cureskin's</p>
          <p class="tw-font-lexend tw-inline-block">
            <span class="tw-text-gray-50" i18n="@@moneyBack">MONEY BACK</span>
            <span class="tw-text-[#c7b189] tw-inline-block tw-mx-1">
              <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="tw-w-3 tw-h-3">
                <path d="M12 2 L14.95 8.6 L22 9.3 L16.8 14.2 L18.3 22 L12 18.3 L5.7 22 L7.2 14.2 L2 9.3 L9.05 8.6 Z" />
              </svg>
            </span>
            <span class="money-back-guarantee-gradient-text tw-uppercase" i18n="@@guarantee">guarantee</span>
          </p>
        </div>
      </div>
      <span class="tw-text-[#B49265] tw-inline-block tw-font-light">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="tw-w-4 tw-h-4 text-[#c7b189]"
          >
            <path
              d="M8 4 L16 12 L8 20"
              stroke="currentColor"
              stroke-width="3.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
        </svg>
        </span>
    </div>
  </div>
</ng-container>
